var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutograph({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16974_13739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.18 29.82L36 27L42.18 24.18L45 18L47.82 24.18L54 27L47.82 29.82L45 36L42.18 29.82ZM12 42L14.82 35.82L21 33L14.82 30.18L12 24L9.18 30.18L3 33L9.18 35.82L12 42ZM25.5 27L28.77 19.77L36 16.5L28.77 13.23L25.5 6L22.23 13.23L15 16.5L22.23 19.77L25.5 27ZM13.5 61.5L31.5 43.47L43.5 55.47L69 26.79L64.77 22.56L43.5 46.47L31.5 34.47L9 57L13.5 61.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16974_13739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutograph);
export default __webpack_public_path__ + "static/media/Autograph.3adf63b6ae3d88c71534810da2ca0722.svg";
export { ForwardRef as ReactComponent };